import { Card, CardContent, TextField } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import CardTitle from "@saleor/components/CardTitle";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import {
  InstagramLabel_instagramLabel,
  InstagramLabel_instagramLabel_instagramList
} from "@saleor/inslabel/types/InstagramLabel";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { ReorderAction } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import LabelInstagram from "../LabelInstagram";

interface InstagramLabelDetailsPagePorps {
  label: InstagramLabel_instagramLabel;
  disabled: boolean;
  onSubmit: (data: InstagramLabelDetailsPageFormData) => void;
  onBack: () => void;
  saveButtonBarState: ConfirmButtonTransitionState;
  labelIns: InstagramLabel_instagramLabel_instagramList[];
  onInsReorder?: ReorderAction;
  onDeleteIns?: (id: string) => void;
  onAddIns?: () => void;
  onRowClick?: (id: string) => void;
  reverseVisible: (data: InstagramLabel_instagramLabel_instagramList[]) => void;
  onInsSelectReorder?: (insId: string, sortOrder: number) => void;
}

export interface InstagramLabelDetailsPageFormData {
  name: string;
}

export const InstagramLabelDetailsPage: React.FC<InstagramLabelDetailsPagePorps> = ({
  label,
  disabled,
  onSubmit,
  onBack,
  saveButtonBarState,
  labelIns,
  onInsReorder,
  onDeleteIns,
  onAddIns,
  onRowClick,
  reverseVisible,
  onInsSelectReorder
}) => {
  const intl = useIntl();

  const initialForm: InstagramLabelDetailsPageFormData =
    label === null
      ? {
          name: ""
        }
      : {
          name: maybe(() => label.name, "")
        };

  const handleSubmit = (data: InstagramLabelDetailsPageFormData) =>
    onSubmit({
      ...data
    });
  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, hasChanged, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.label)}
          </AppHeader>
          <PageHeader
            title={intl.formatMessage({
              defaultMessage: "Content Label Details",
              description: "Content Label Details"
            })}
          />
          <Grid>
            <Card>
              <CardTitle
                title={intl.formatMessage(commonMessages.generalInformations)}
              ></CardTitle>
              <CardContent>
                <TextField
                  disabled={disabled}
                  label={intl.formatMessage({
                    defaultMessage: "Label Name",
                    description: "Label Name"
                  })}
                  name={"name" as keyof InstagramLabelDetailsPageFormData}
                  fullWidth
                  value={data.name}
                  onChange={change}
                />
              </CardContent>
            </Card>
            <FormSpacer />
            <Card>
              <LabelInstagram
                productIns={labelIns}
                onInsReorder={onInsReorder}
                onDeleteIns={onDeleteIns}
                onAddIns={onAddIns}
                onRowClick={onRowClick}
                reverseVisible={reverseVisible}
                onInsSelectReorder={onInsSelectReorder}
              ></LabelInstagram>
            </Card>
          </Grid>
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            state={saveButtonBarState}
            onCancel={onBack}
            onSave={submit}
          />
        </Container>
      )}
    </Form>
  );
};

export default InstagramLabelDetailsPage;
